import { FormControl, Grid, MenuItem, Select, Typography } from "@mui/material";
import { useFormikContext } from "formik";
import { useTranslation } from "react-i18next";

export function ClientDropdown({ clientList, onChange }) {
  const { t } = useTranslation();
  const { values, setFieldValue } = useFormikContext();

  return (
    <Grid container alignItems="center">
      <Grid item xs={4}>
        <Typography>{t("tool.addEdit.clients", "Clients")}</Typography>
      </Grid>
      <Grid item xs={8}>
        <FormControl fullWidth>
          <Select
            value={values.clientId || ""}
            variant="outlined"
            fullWidth
            displayEmpty
            onChange={e => {
              setFieldValue("clientId", e.target.value);
              onChange(e.target.value);
            }}
          >
            <MenuItem value="">
              <em>{t("tool.addEdit.none", "none assigned")}</em>
            </MenuItem>
            {clientList?.map(c => (
              <MenuItem key={c._id} value={c._id}>
                {c.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
    </Grid>
  );
}
